import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import ShipmentTableRow from './ShipmentTableRow';

const ShipmentTable = ({ shipments, onStatusUpdate, onDeleted, onArchived, userRole }) => {
  const [sortConfig, setSortConfig] = useState({ key: 'createdAt', direction: 'desc' });

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev?.key === key && prev?.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const sortedShipments = [...(shipments || [])]?.sort((a, b) => {
    const aValue = a?.[sortConfig?.key];
    const bValue = b?.[sortConfig?.key];

    if (sortConfig?.key === 'createdAt') {
      return sortConfig?.direction === 'asc'
        ? new Date(aValue) - new Date(bValue)
        : new Date(bValue) - new Date(aValue);
    }

    if (typeof aValue === 'string') {
      return sortConfig?.direction === 'asc'
        ? aValue?.localeCompare(bValue)
        : bValue?.localeCompare(aValue);
    }

    return sortConfig?.direction === 'asc' ? aValue - bValue : bValue - aValue;
  });

  const SortIcon = ({ columnKey }) => {
    if (sortConfig?.key !== columnKey) {
      return <Icon name="ChevronsUpDown" size={14} className="text-gray-400 ml-1" />;
    }
    return sortConfig?.direction === 'asc'
      ? <Icon name="ChevronUp" size={14} className="text-green-600 ml-1" />
      : <Icon name="ChevronDown" size={14} className="text-green-600 ml-1" />;
  };

  const thClass = "px-3 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider whitespace-nowrap";
  const thSortClass = `${thClass} cursor-pointer hover:bg-gray-100 transition-colors`;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      {/* Table header accent */}
      <div className="h-1 bg-gradient-to-r from-green-600 to-green-400" />
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-100">
          <thead className="bg-gray-50">
            <tr>
              <th className={thSortClass} onClick={() => handleSort('reference')}>
                <div className="flex items-center">
                  Référence <SortIcon columnKey="reference" />
                </div>
              </th>
              <th className={thSortClass} onClick={() => handleSort('senderName')}>
                <div className="flex items-center">
                  Expéditeur <SortIcon columnKey="senderName" />
                </div>
              </th>
              <th className={thSortClass} onClick={() => handleSort('receiverName')}>
                <div className="flex items-center">
                  Destinataire <SortIcon columnKey="receiverName" />
                </div>
              </th>
              <th className={thSortClass} onClick={() => handleSort('receiverCity')}>
                <div className="flex items-center">
                  Ville dest. <SortIcon columnKey="receiverCity" />
                </div>
              </th>
              <th className={thClass}>
                Articles
              </th>
              <th className={thSortClass} onClick={() => handleSort('status')}>
                <div className="flex items-center">
                  Statut <SortIcon columnKey="status" />
                </div>
              </th>
              <th className={thSortClass} onClick={() => handleSort('paymentStatus')}>
                <div className="flex items-center">
                  Paiement <SortIcon columnKey="paymentStatus" />
                </div>
              </th>
              <th className={thSortClass} onClick={() => handleSort('totalAmount')}>
                <div className="flex items-center">
                  Montant TTC <SortIcon columnKey="totalAmount" />
                </div>
              </th>
              <th className={thSortClass} onClick={() => handleSort('createdAt')}>
                <div className="flex items-center">
                  Date <SortIcon columnKey="createdAt" />
                </div>
              </th>
              <th className={thClass}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {sortedShipments?.map((shipment) => (
              <ShipmentTableRow
                key={shipment?.id}
                shipment={shipment}
                onStatusUpdate={onStatusUpdate}
                onDeleted={onDeleted}
                onArchived={onArchived}
                userRole={userRole}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ShipmentTable;